var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPackageCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6431 16.7571L18.6431 18.7571L22.6431 14.7571",
    stroke: "#1B1C1B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6431 10.7571V8.7571C21.6427 8.40638 21.5501 8.06191 21.3746 7.75827C21.1991 7.45462 20.9468 7.20247 20.6431 7.0271L13.6431 3.0271C13.339 2.85157 12.9941 2.75916 12.6431 2.75916C12.292 2.75916 11.9471 2.85157 11.6431 3.0271L4.64307 7.0271C4.33933 7.20247 4.08705 7.45462 3.91153 7.75827C3.73601 8.06191 3.64343 8.40638 3.64307 8.7571V16.7571C3.64343 17.1078 3.73601 17.4523 3.91153 17.7559C4.08705 18.0596 4.33933 18.3117 4.64307 18.4871L11.6431 22.4871C11.9471 22.6626 12.292 22.7551 12.6431 22.7551C12.9941 22.7551 13.339 22.6626 13.6431 22.4871L15.6431 21.3471",
    stroke: "#1B1C1B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.14307 5.0271L17.1431 10.1771",
    stroke: "#1B1C1B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.93311 7.75708L12.6431 12.7571L21.3531 7.75708",
    stroke: "#1B1C1B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6431 22.7571V12.7571",
    stroke: "#1B1C1B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPackageCheck);
export default __webpack_public_path__ + "static/media/package-check.cf212b655268cdaf284f5e9b60894ee5.svg";
export { ForwardRef as ReactComponent };